import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { Http, Headers, HttpModule } from '@angular/http';
import { IonicStorageModule } from '@ionic/storage';
import { HTTP } from '@ionic-native/http/ngx';
import { ConfermaPage } from '../pages/conferma/conferma';
import { DettaglioPage } from '../pages/dettaglio/dettaglio';
import { CreditsPage } from '../pages/credits/credits';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ConfermaPage,
    DettaglioPage,
    CreditsPage

  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ConfermaPage,
    DettaglioPage, 
    CreditsPage

  ],
  providers: [
    StatusBar,
    Storage,
    HTTP,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts